import React, { useState, useEffect } from "react";
import { useCookieConsent } from "../../contexts/CookieConsentContext";
import CookieConsentBanner from "./CookieConsentBanner";
import CookiePreferencesDialog from "./CookiePreferencesDialog";

const CookieConsent: React.FC = () => {
  const { showBanner } = useCookieConsent();
  const [showPreferences, setShowPreferences] = useState(false);

  useEffect(() => {
    const handleShowCookiePreferences = () => {
      setShowPreferences(true);
    };

    // Listen for custom event from footer
    window.addEventListener(
      "showCookiePreferences",
      handleShowCookiePreferences
    );

    return () => {
      window.removeEventListener(
        "showCookiePreferences",
        handleShowCookiePreferences
      );
    };
  }, []);

  const handleShowPreferences = () => {
    setShowPreferences(true);
  };

  const handleClosePreferences = () => {
    setShowPreferences(false);
  };

  return (
    <>
      {showBanner && !showPreferences && (
        <CookieConsentBanner onShowPreferences={handleShowPreferences} />
      )}
      <CookiePreferencesDialog
        open={showPreferences}
        onClose={handleClosePreferences}
      />
    </>
  );
};

export default CookieConsent;
